import React from 'react';
import ReactDOM from 'react-dom';
//semantic-ui-css
import 'semantic-ui-css/semantic.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { createFirestoreInstance} from 'redux-firestore';
import { firebase } from './config/fbConfig';
import rootReducer from "./store/reducers/rootReducer";
import {applyMiddleware, compose, createStore} from "redux";
import ReduxToastr from 'react-redux-toastr';
import thunk from "redux-thunk";

// react-redux-firebase config
const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
};

const store = createStore(rootReducer, compose(
  applyMiddleware(thunk)
  // window.navigator.userAgent.includes('Chrome') ?
  //   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : compose
));

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance // <- needed if using firestore
};

ReactDOM.render(<Provider
  store={store}>
  <ReactReduxFirebaseProvider {...rrfProps}><App /></ReactReduxFirebaseProvider>
  <ReduxToastr
    timeOut={4000}
    newestOnTop={false}
    preventDuplicates
    position="bottom-right"
    transitionIn="fadeIn"
    transitionOut="fadeOut"
    progressBar
    closeOnToastrClick/>
</Provider>, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
